import * as utils from "@utils/index";
import zhCN from "./zh-CN";
import zhTW from "./zh-TW";

export default () => {
  const languageList = ["zh-CN", "zh-TW"];
  const totalLanguageList = [
    "zh-CN",
    "zh-TW",
    "en-US",
    "ja-JP",
    "ko-KR",
    "th-TH",
    "vi-VN",
    "de-DE",
    "fr-FR",
    "ru-RU",
    "es-ES",
    "pt-PT",
    "it-IT",
    "tr-TR",
    "pl-PL",
    "id-ID",
    "ar-SA",
  ]; // 全部语言列表, 17种语言
  const pageInfo = {
    "zh-CN": { title: "", ico: "" },
    "zh-TW": { title: "", ico: "" },
    "en-US": { title: "", ico: "" },
    "ja-JP": { title: "", ico: "" },
    "ko-KR": { title: "", ico: "" },
    "th-TH": { title: "", ico: "" },
    "vi-VN": { title: "", ico: "" },
    "de-DE": { title: "", ico: "" },
    "fr-FR": { title: "", ico: "" },
    "ru-RU": { title: "", ico: "" },
    "es-ES": { title: "", ico: "" },
    "pt-PT": { title: "", ico: "" },
    "it-IT": { title: "", ico: "" },
    "tr-TR": { title: "", ico: "" },
    "pl-PL": { title: "", ico: "" },
    "id-ID": { title: "", ico: "" },
    "ar-SA": { title: "", ico: "" },
  };
  const defaultLang = "zh-TW"; // 默认语言, 单语言配置
  const languageTxt = {
    "zh-CN": zhCN,
    "zh-TW": zhTW,
  };

  const getSystemLanguage = () => {
    let res =
      navigator.language ||
      navigator.userLanguage ||
      navigator.browerLanguage ||
      navigator.systemLanguage;
    if (res.indexOf("-") > -1) {
      const langArr = res.split("-");
      res = langArr[0] === "zh" ? langArr[1] : langArr[0];
    }
    return res.toLowerCase();
  };
  const checkLanguage = (lang) => {
    let res = "";
    if (lang) {
      if (lang.indexOf("-") > -1) {
        for (let i = 0; i < languageList.length; i++) {
          if (languageList[i] === lang) {
            res = languageList[i];
          }
        }
      } else {
        const reg = new RegExp(lang, "g");
        for (let i = 0; i < languageList.length; i++) {
          if (reg.test(languageList[i].toLowerCase())) {
            res = languageList[i];
          }
        }
      }
    }
    return res;
  };
  let curLang =
    defaultLang ||
    checkLanguage(utils.getUrlParams("appLanguage")) ||
    checkLanguage(utils.getUrlParams("language")) ||
    checkLanguage(getSystemLanguage()) ||
    checkLanguage("zh-TW");
  const initLang = () => {
    document.body.className += " " + curLang;
    document
      .getElementsByTagName("html")[0]
      .setAttribute("dir", curLang == "ar-SA" ? "rtl" : "ltr");

    if (!pageInfo[curLang]) return;
    if (pageInfo[curLang].title) {
      document.title = pageInfo[curLang].title;
    }
    if (pageInfo[curLang].ico) {
      try {
        document
          .getElementById("icon")
          .setAttribute("href", pageInfo[curLang].ico);
        document
          .getElementById("shortcut")
          .setAttribute("href", pageInfo[curLang].ico);
      } catch (e) {}
    }
  };

  const getLangTxt = (key, msg) => {
    let info = languageTxt[curLang] || languageTxt["en-US"];
    return info[key] || String(msg);
  };

  const getLangCode = (lang) => {
    let code = "";
    if (lang.indexOf("-") > -1) {
      const langArr = lang.split("-");
      code = langArr[0] === "zh" ? langArr[1] : langArr[0];
    }
    return code.toLowerCase();
  };

  const addMeta = (metaname, content) => {
    const meta = document.createElement("meta");
    meta.content = content;
    meta.name = metaname;
    document.getElementsByTagName("head")[0].appendChild(meta);
  };

  return {
    curLang,
    initLang,
    getLangTxt,
    getLangCode,
    addMeta,
    langData: languageTxt[curLang] || {},
  };
};
